export type CartBilling = {
  discount: number;
  handling_total: number;
  shipping_discount: number;
  shipping_subtotal: number;
  shipping_total: number;
  shipping_at_cost: boolean;
  subtotal: number;
  tax: number;
  total: number;
};
